module.exports = __webpack_public_path__ + "img/google-display-phone.a30d5a6d.png";